import { driver, DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import { baseTourConfig, injectTourStyles } from './tourConfig';
import { TourId } from '@/store/tourStore';

export const TOUR_ID: TourId = 'publish-registration';

export const createSteps = (navigate: (path: string) => void): DriveStep[] => [
  {
    popover: {
      title: 'Publish Your Registration',
      description: 'Registration forms let teams sign up for your seasons or tournaments. You can collect payments, waivers, and custom information. Let\'s create one!',
      side: 'over',
      align: 'center',
    },
  },
  {
    element: '[data-tour="nav-registration"]',
    popover: {
      title: 'Go to Team Registration',
      description: 'Click here to access the registration management page where you can create and manage registration forms.',
      side: 'right',
      align: 'start',
      onNextClick: (element, step, options) => {
        navigate('/admin/registration');
        setTimeout(() => {
          options.driver.moveNext();
        }, 500);
      },
    },
  },
  {
    element: '[data-tour="create-registration-btn"]',
    popover: {
      title: 'Create Registration',
      description: 'Click this button to create a registration. Pick the tournament or season it belongs to, then configure pricing, dates, and form fields on the edit page, and activate it when it\'s ready.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="registration-list"]',
    popover: {
      title: 'Your Registrations',
      description: 'All your registration forms appear here. Active registrations show a green badge - click on them to view signups and manage teams.',
      side: 'top',
      align: 'center',
    },
  },
  // The 'Set Up Payments' step targeting nav-payment-products was removed
  // 2026-08-25 with the Pricing nav entry — fees are now created inline on
  // each registration's Payments pane (a broken selector is worse than a
  // missing step).
];

export const startPublishRegistrationTour = (onComplete?: () => void, navigate?: (path: string) => void) => {
  injectTourStyles();

  const steps = createSteps(navigate || (() => {}));
  
  const driverObj = driver({
    ...baseTourConfig,
    steps,
    onDestroyStarted: () => {
      onComplete?.();
      driverObj.destroy();
    },
  });

  driverObj.drive();
  return driverObj;
};
